var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReguateLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 12,
    viewBox: "0 0 20 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.482 7.64392C13.5506 7.71417 13.6364 7.78441 13.7221 7.85465C14.4082 8.45173 15.3002 8.80296 16.2779 8.80296C18.0274 8.80296 19.5026 7.66148 20 6.08098C19.9828 7.32782 19.5026 8.5571 18.5763 9.5054C16.6724 11.4547 13.5849 11.4547 11.681 9.5054L6.53516 4.32486C6.46655 4.25462 6.38079 4.18437 6.29503 4.11413C5.60892 3.51705 4.71698 3.16583 3.73928 3.16583C1.97255 3.16583 0.497427 4.32486 0 5.90537C0.0171527 4.65852 0.497426 3.41168 1.42367 2.46338C3.32761 0.514091 6.41509 0.514091 8.31904 2.46338L13.482 7.64392Z",
    fill: "#009F0C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2796 3.46443C19.0223 2.92003 18.6278 2.41076 18.1475 2.02441C16.2779 0.443908 13.3448 0.707325 11.6638 2.42832L10.3774 3.74541L12.2127 5.58933L13.482 4.2898C14.3739 3.37662 15.8491 3.37662 16.741 4.2898C17.6329 5.20298 17.6329 6.71324 16.741 7.62642C16.4665 7.9074 16.1235 8.11813 15.7633 8.2235C15.9177 8.24106 16.0892 8.25862 16.2607 8.25862C17.6158 8.25862 18.9022 7.41569 19.4168 6.11616C19.777 5.22054 19.6741 4.2898 19.2796 3.46443Z",
    fill: "#009F0C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.7873 6.37953L6.50085 7.67906C5.60891 8.59224 4.13378 8.59224 3.24184 7.67906C2.34991 6.76588 2.34991 5.25562 3.24184 4.34244C3.51629 4.06146 3.85934 3.85073 4.21955 3.74536C4.06518 3.7278 3.89365 3.71024 3.72212 3.71024C1.85248 3.71024 0.325892 5.2205 0.325892 7.09954C0.325892 8.39907 1.21783 9.57566 2.24699 10.2605C4.13378 11.5074 6.72384 11.1913 8.30188 9.57566L9.60548 8.25858L7.7873 6.37953Z",
    fill: "#009F0C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReguateLogo);
export default __webpack_public_path__ + "static/media/reguateLogo.3d80a4f189c3cb9a4670c4b53b5488b3.svg";
export { ForwardRef as ReactComponent };